import { createReducer } from 'store/helpers';
import {
  SET_ERROR,
  CLEAR_ERROR,
  REQUEST_STARTED,
  REQUEST_COMPLETED,
  SET_METRICS,
  SET_SERVICE_METRICS,
  SET_LINK_METRICS,
  SET_METRICS_DURATION,
  SET_RECIPIENT_METRICS,
} from 'store/actions/metrics';
import { addIdPrefix } from 'services/common';

const initialState = {
  metrics: [],
  serviceMetrics: [],
  linkMetrics: [],
  recipientMetrics: [],
  isFetching: false,
  error: '',
};

const setError = (state, { error }) =>
  state.merge({ error: addIdPrefix(error) });

const clearError = state => state.merge({ error: '' });

const requestStarted = state => state.merge({ isFetching: true });

const requestCompleted = state => state.merge({ isFetching: false });

const setMetrics = (state, { metrics }) => state.merge({ metrics });

const setMetricsDuration = (state, { dates }) => state.merge({ dates });

const setServiceMetrics = (state, { serviceMetrics }) =>
  state.merge({ serviceMetrics });

const setLinkMetrics = (state, { linkMetrics }) => state.merge({ linkMetrics });

const setRecipientMetrics = (state, { recipientMetrics }) =>
  state.merge({ recipientMetrics });

const handlers = {
  [SET_ERROR]: setError,
  [CLEAR_ERROR]: clearError,
  [REQUEST_STARTED]: requestStarted,
  [REQUEST_COMPLETED]: requestCompleted,
  [SET_METRICS]: setMetrics,
  [SET_METRICS_DURATION]: setMetricsDuration,
  [SET_SERVICE_METRICS]: setServiceMetrics,
  [SET_LINK_METRICS]: setLinkMetrics,
  [SET_RECIPIENT_METRICS]: setRecipientMetrics,
};

export default createReducer(initialState, handlers);
